const ZERO_COLLIDING_SIDES = (aggregateCollisions) =>
  Boolean(!aggregateCollisions.top && !aggregateCollisions.bottom && !aggregateCollisions.left && !aggregateCollisions.right);

const ALL_COLLIDING_SIDES = (aggregateCollisions) =>
  Boolean(aggregateCollisions.top && aggregateCollisions.bottom && aggregateCollisions.left && aggregateCollisions.right);

const TOP_AND_BOTTOM_COLLIDING = (aggregateCollisions) => Boolean(aggregateCollisions.top && aggregateCollisions.bottom);

const TOP_OR_BOTTOM_COLLIDING = (aggregateCollisions) => Boolean(aggregateCollisions.top || aggregateCollisions.bottom);

const LEFT_AND_RIGHT_COLLIDING = (aggregateCollisions) => Boolean(aggregateCollisions.left && aggregateCollisions.right);

const LEFT_OR_RIGHT_COLLIDING = (aggregateCollisions) => Boolean(aggregateCollisions.left || aggregateCollisions.right);

export const getNextPositionFromEdges = (currentPosition, aggregateCollisions, flipItFlipItGood) => {
  //   e.g. top/bottom           e.g. left/right
  let [currentVerticalAlignment, currentHorizontalAlignment] = currentPosition.split('-');

  if (flipItFlipItGood) {
    [currentHorizontalAlignment, currentVerticalAlignment] = [currentVerticalAlignment, currentHorizontalAlignment];
  }

  switch (true) {
    case ZERO_COLLIDING_SIDES(aggregateCollisions):
      return [currentPosition];

    case ALL_COLLIDING_SIDES(aggregateCollisions):
      return flipItFlipItGood ? ['left', 'bottom'] : ['bottom', 'left'];

    case TOP_AND_BOTTOM_COLLIDING(aggregateCollisions) && LEFT_OR_RIGHT_COLLIDING(aggregateCollisions):
      return ['bottom', aggregateCollisions.left ? 'left' : 'right'];

    case TOP_AND_BOTTOM_COLLIDING(aggregateCollisions) && !LEFT_OR_RIGHT_COLLIDING(aggregateCollisions):
      return ['bottom', currentHorizontalAlignment];

    case TOP_OR_BOTTOM_COLLIDING(aggregateCollisions) && LEFT_OR_RIGHT_COLLIDING(aggregateCollisions):
      return [aggregateCollisions.top ? 'bottom' : 'top', aggregateCollisions.left ? 'left' : 'right'];

    case TOP_OR_BOTTOM_COLLIDING(aggregateCollisions) && !LEFT_OR_RIGHT_COLLIDING(aggregateCollisions):
      return [aggregateCollisions.top ? 'bottom' : 'top', currentHorizontalAlignment];

    case LEFT_AND_RIGHT_COLLIDING(aggregateCollisions):
      return [currentVerticalAlignment, 'left'];

    case LEFT_OR_RIGHT_COLLIDING(aggregateCollisions):
      return [currentVerticalAlignment, aggregateCollisions.left ? 'left' : 'right'];

    default:
      return currentPosition;
  }
};
